(async () => {
  const script = document.currentScript;
  const endpoint = script && script.dataset.auditApi;
  const fields = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  const sourceKey = 'kathare.originalAcquisition';
  const cartKey = 'kathare.auditCartAttribution';
  const params = new URLSearchParams(location.search);
  let original = {};
  let pending = null;
  try {
    original = JSON.parse(localStorage.getItem(sourceKey) || '{}');
    pending = JSON.parse(localStorage.getItem(cartKey) || 'null');
    const source = params.get('utm_source');
    if (!original.utm_source && source && !['hair_scalp_audit', 'scalp_audit'].includes(source)) {
      original = {};
      for (const key of fields) {
        const value = params.get(key);
        if (value && /^[A-Za-z0-9_. -]{1,100}$/.test(value)) original[key] = value;
      }
      localStorage.setItem(sourceKey, JSON.stringify(original));
    }
  } catch { original = {}; pending = null; }
  const ref = params.get('audit_ref');
  if (ref && endpoint) {
    try {
      const response = await fetch(endpoint, {
        method: 'POST', credentials: 'omit',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ audit_ref: ref, original_acquisition: original }),
      });
      if (response.ok) {
        const data = await response.json();
        if (data.recorded && /^[A-Za-z0-9_-]{8,80}$/.test(data.audit_session_id) && /^[a-z_]{1,64}$/.test(data.result_profile)) {
          pending = data;
          try { localStorage.setItem(cartKey, JSON.stringify(data)); } catch {}
        }
      }
    } catch {}
  }
  if (!pending) return;
  try {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const cartResponse = await fetch(root + 'cart.js', { credentials: 'same-origin' });
    if (!cartResponse.ok) return;
    const cart = await cartResponse.json();
    const attributes = { ...(cart.attributes || {}) };
    const next = {
      audit_session_id: pending.audit_session_id,
      audit_result_profile: pending.result_profile,
      audit_assist_source: 'hair_scalp_audit',
    };
    const source = pending.original_acquisition || {};
    if (source.utm_source && !attributes.original_acquisition_source) next.original_acquisition_source = source.utm_source;
    if (source.utm_campaign && !attributes.original_acquisition_campaign) next.original_acquisition_campaign = source.utm_campaign;
    if (Object.entries(next).every(([key, value]) => attributes[key] === value)) return;
    await fetch(root + 'cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { ...attributes, ...next } }),
    });
  } catch {}
})();
